// Nashville Number System Theory Logic

const NOTES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
const FLAT_NOTES = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];
const MAJOR_SCALE_INTERVALS = [0, 2, 4, 5, 7, 9, 11]; // W-W-H-W-W-W-H

// Number names and chord qualities
const NUMBER_INFO = {
  1: { roman: 'I', quality: 'maj', suffix: '' },
  2: { roman: 'ii', quality: 'min', suffix: 'm' },
  3: { roman: 'iii', quality: 'min', suffix: 'm' },
  4: { roman: 'IV', quality: 'maj', suffix: '' },
  5: { roman: 'V', quality: 'maj', suffix: '' },
  6: { roman: 'vi', quality: 'min', suffix: 'm' },
  7: { roman: 'vii°', quality: 'dim', suffix: 'dim' }
};

// Keys that use flat notation
const FLAT_KEYS = ['F', 'Bb', 'Eb', 'Ab', 'Db', 'Gb'];

export const getScaleNotes = (key) => {
  const useFlats = FLAT_KEYS.includes(key);
  const noteList = useFlats ? FLAT_NOTES : NOTES;
  
  let rootIdx;
  if (FLAT_NOTES.includes(key)) {
    rootIdx = FLAT_NOTES.indexOf(key);
  } else {
    rootIdx = NOTES.indexOf(key);
  }
  
  return MAJOR_SCALE_INTERVALS.map(interval => noteList[(rootIdx + interval) % 12]);
};

export const getChordForNumber = (key, number) => {
  const scale = getScaleNotes(key);
  const root = scale[number - 1];
  const { roman, quality, suffix } = NUMBER_INFO[number];
  
  return {
    root,
    quality,
    roman,
    suffix,
    chordName: `${root}${suffix}`
  };
};

export const getNumberForChord = (key, chordRoot) => {
  const scale = getScaleNotes(key);
  
  for (let i = 0; i < scale.length; i++) {
    if (scale[i] === chordRoot) {
      return i + 1;
    }
    // Handle enharmonic equivalents
    const noteIdx = NOTES.indexOf(scale[i]);
    if (noteIdx !== -1 && FLAT_NOTES[noteIdx] === chordRoot) {
      return i + 1;
    }
  }
  return null;
};

export const generateQuestion = (keys, mode) => {
  const key = keys[Math.floor(Math.random() * keys.length)];
  const number = Math.floor(Math.random() * 7) + 1;
  const chord = getChordForNumber(key, number);
  
  if (mode === 'number_to_chord') {
    return {
      type: 'number_to_chord',
      key,
      number: Number(number),
      question: `What chord is ${number} in ${key}?`,
      answer: chord.chordName,
      answerDetails: chord
    };
  } else {
    return {
      type: 'chord_to_number',
      key,
      number: Number(number),
      chord: chord.chordName,
      question: `What number is ${chord.chordName} in ${key}?`,
      answer: Number(number),
      answerDetails: chord
    };
  }
};

export const getFullChart = (key) => {
  const scale = getScaleNotes(key);
  return Array.from({ length: 7 }, (_, i) => ({
    number: i + 1,
    ...getChordForNumber(key, i + 1)
  }));
};

export const ALL_KEYS = [
  { name: 'C', display: 'C Major', accidentals: 0 },
  { name: 'G', display: 'G Major', accidentals: 1 },
  { name: 'D', display: 'D Major', accidentals: 2 },
  { name: 'A', display: 'A Major', accidentals: 3 },
  { name: 'E', display: 'E Major', accidentals: 4 },
  { name: 'B', display: 'B Major', accidentals: 5 },
  { name: 'F#', display: 'F# Major', accidentals: 6 },
  { name: 'F', display: 'F Major', accidentals: 1 },
  { name: 'Bb', display: 'Bb Major', accidentals: 2 },
  { name: 'Eb', display: 'Eb Major', accidentals: 3 },
  { name: 'Ab', display: 'Ab Major', accidentals: 4 },
  { name: 'Db', display: 'Db Major', accidentals: 5 },
];

export default {
  getScaleNotes,
  getChordForNumber,
  getNumberForChord,
  generateQuestion,
  getFullChart,
  ALL_KEYS,
  NUMBER_INFO
};
